import { useQuery } from '@tanstack/react-query';
import { getLessonDetails } from '../../queries/DailySchedule/scheduleContent';

/**
 * Detalhe da aula em GET /lessons/:slug.
 *
 * O payload que monta a agenda do dia (/cronograma/:id/conteudo/dia) devolve um
 * IPALessonDto, que não traz `captionUri`. Quem precisa saber se a aula tem
 * transcrição — hoje o PlayerSection — busca o detalhe por aqui.
 *
 * Era um useMutation com mutationKey fixa: sem cache por aula e com disparo
 * manual. Como query fica cacheado por slug e dispara sozinho.
 */
export function useGetLessonDetail(slug?: string) {
  const { data, isPending, isError } = useQuery({
    queryKey: ['getLessonDetail', slug],
    queryFn: () => getLessonDetails(slug as string),
    enabled: Boolean(slug),
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return { data, isPending, isError };
}
